import React, {useMemo} from "react"
import {Link} from "react-router-dom"
import classNames from "classnames"
import moment from "moment"
import useAuth from "auth/useAuth"
import useRescuers from "hooks/useRescuers"
import {daysTo} from "utils/utils"
import "./SummerWeek.css"

export default function SummerWeek(props) {

    const {week, applications, onClick} = props
    const {username} = useAuth()
    const {getUser} = useRescuers()

    const past = useMemo(() => daysTo(week) < 0, [week])

    const weekApps = useMemo(() => {
        if (!applications) return []
        return applications.filter(app => app.week === week)
    }, [week, applications])

    const applied = useMemo(
        () => weekApps.some(app => app.username === username),
        [weekApps, username]
    )

    const onWeekClick = (event) => {
        if (past) return
        if (event.target.closest("a")) return
        if (onClick) onClick(week)
    }

    return <div className={classNames("summer-week", {"applied": applied, "past": past, "clickable": !past})} onClick={onWeekClick}>
        <div className="summer-week-header">
            <h4>{moment(week).format("Do MMMM YYYY.")}</h4>
            {applied && <span className="status-label status-applied">Prijavljen</span>}
            {past && !applied && <span className="status-label status-past">Prošla</span>}
        </div>
        {weekApps.length > 0 && <ol className="summer-week-rescuers">
            {weekApps.map(app => {
                const rescuer = getUser(app.rescuer.username) || app.rescuer
                return <li key={app.username}>
                    <Link to={`/rescuer/${rescuer.username}`}>
                        {rescuer.given_name} {rescuer.family_name}
                        {rescuer.nickname && ` "${rescuer.nickname}"`}
                        {rescuer.gss_id && ` ${rescuer.gss_id}`}
                    </Link>
                </li>
            })}
        </ol>}
    </div>
}
